import * as requestFromServer from "./projectCategoryCrud";
import { projectCategorySlice, callTypes } from "./projectCategorySlice";
import { actions as auth } from "../../../Auth/_redux/authRedux";
import { toastOption } from "../../../../../_metronic/_helpers/ToastHelpers";
import { toast } from "react-toastify";

const { actions } = projectCategorySlice;

export const fetchProjectCategories = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findProjectCategory(queryParams)
    .then(response => {
      const {
        data: { total_items, items }
      } = response.data;
      dispatch(actions.projectCategoriesFetched({ total_items, items }));
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchCategoryProject = (id) => dispatch => {
  if (!id) {
    return dispatch(actions.projectCategoryFetched({ projectCategoryForEdit: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getProjectCategoryById(id)
    .then(response => {
      const { data: projectCategory } = response.data;
      console.log(projectCategory);
      dispatch(
        actions.projectCategoryFetched({
          projectCategoryForEdit: projectCategory
        })
      );
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createProjectCategory = (projectCategoryForCreation) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createProjectCategory(projectCategoryForCreation)
    .then(response => {
      dispatch(actions.projectCategoryReload);
      return response.data;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const updateProjectCategory = (projectCategory) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateProjectCategory(projectCategory)
    .then(response => {
      dispatch(actions.projectCategoryReload);
      return response.data;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const deleteProjectCategory = (uuid) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteProjectCategory(uuid)
    .then(response => {
      dispatch(actions.projectCategoryReload);
      return response.data;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

